module.exports = __webpack_public_path__ + "static/media/customers7.e90b9604.png";